import 'core-js/stable';
import 'regenerator-runtime/runtime';

import renderClientSideApp from '../entry.client';

renderClientSideApp();
